// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fraction_type_enum_26cb99fd */
var FractionTypeEnum26cb99fd;
(function (FractionTypeEnum26cb99fd) {
    FractionTypeEnum26cb99fd["broth"] = "broth";
    FractionTypeEnum26cb99fd["supernatant"] = "supernatant";
    FractionTypeEnum26cb99fd["powder"] = "powder";
    FractionTypeEnum26cb99fd["pellet"] = "pellet";
})(FractionTypeEnum26cb99fd || (FractionTypeEnum26cb99fd = {}));
;
export default FractionTypeEnum26cb99fd;
/** Zod schema for fraction_type_enum_26cb99fd */
export const fractionTypeEnum26cb99fd = z.nativeEnum(FractionTypeEnum26cb99fd);
//# sourceMappingURL=FractionTypeEnum26cb99fd.js.map